<app-navbar-one></app-navbar-one>

<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Portfolio</h2>
                    <!-- <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Portfolio</li>
                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</div>

<section class="protfolio-section ptb-100 pt-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-protfolio-box">
                    <div class="image">
                        <a routerLink="/projects-details"><img src="assets/img/protfolio/img1.png" alt="image"></a>
                    </div>
                    <div class="content">
                        <h3>Creative Web Develop</h3>
                        <span>Web Design</span>
                        <a routerLink="/projects-details" class="link-btn"></a>
                    </div>
                </div>
            </div>
            
            <!-- <div class="col-lg-12 col-md-12">
                <div class="pagination-area">
                    <a routerLink="/projects-two" class="prev page-numbers"><i class="flaticon-left"></i></a>
                    <a routerLink="/projects-two" class="page-numbers">1</a>
                    <span class="page-numbers current" aria-current="page">2</span>
                    <a routerLink="/projects-two" class="page-numbers">3</a>
                    <a routerLink="/projects-two" class="page-numbers">4</a>
                    <a routerLink="/projects-two" class="next page-numbers"><i class="flaticon-right"></i></a>
                </div>
            </div> -->
        </div>
    </div>
</section>